import React from 'react'
import PropTypes from 'prop-types'
import { Label, Table, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'

const Enquadramento = (props) => (
  <CRUDIndex
    title='Enquadramentos'
    icon='object group'
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} textAlign='center'
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell
            onClick={props.handleSort('modalidade')}
            sorted={props.handleSorted('modalidade')}>Modalidade</Table.HeaderCell>
          <Table.HeaderCell width={5}>Subgrupos</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan='4'>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}
        {props.multipleEnquadramento.valueSeq().map((enquadramento, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/enquadramentos/${enquadramento.get('id')}`}>
                {enquadramento.get('id')}
              </Label>
            </Table.Cell>
            <Table.Cell>{enquadramento.get('modalidade')}</Table.Cell>
            <Table.Cell>
              <div className='labelListWrapper'>
                {enquadramento.get('subgrupos').map((subgrupo, index) => (
                  <div key={index} className='labelWrapper'>
                    <Label key={index} as={Link} to={`/subgrupos/${subgrupo.get('id')}`}>
                      {subgrupo.get('nome')}
                    </Label>
                  </div>
                ))}
              </div>
            </Table.Cell>
            <Table.Cell>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(enquadramento.get('id'))}
                onDeleteResource={() => props.onDeleteResource(enquadramento.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

Enquadramento.propTypes = {
  onRedirectToNew: PropTypes.func,
  multipleEnquadramento: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default Enquadramento
